import { atom, useAtom } from "jotai";
import { State } from "./State";
import axios from "axios";
import { fetchBase, postBase } from "./BaseApi";

export type UserQuizAnswer = {
  quizSequence: number;
  answeredAt: string;
  userId: string;
  quizId: string;
  isCorrect: boolean;
};

export type UsersQuizAnswer = {
  userId: string;
  quizId: string;
  userQuizAnswerList: UserQuizAnswer[];
};

type Param = {
  quizId: string;
};

const uri = "api/users/quiz-answer";

export const fetchUsersQuizAnswerAtom = atom<State<UsersQuizAnswer> | null>(
  null
);
export const fetchUsersQuizAnswer = () => {
  return fetchBase<UsersQuizAnswer, Param>(uri, fetchUsersQuizAnswerAtom);
};
